/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useEffect, useContext, useState } from 'react';
import './LandingPage.scss';
import { SiteContext } from '../../../context/SiteContext';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import {
    DowntimeMessageType,
    PageNames,
    RoutePaths
} from '../../../Constants/Common';
import AuthenticationButton from '../../common/auth/AuthenticationButton';
import { GoogleAnalytics } from '../../../classes/GoogleAnalytics';
import { SiteApi } from '../../../api/SiteApi';
import DowntimeComponent from '../../common/downtime/DowntimeComponent';
import { DowntimeConfigResponse } from '../../common/CommonTypes';

const LandingPage = (): JSX.Element => {
    const { isAuthenticated, user, logout } = useAuth0();
    const navigate = useNavigate();
    const { brandId } = useContext(SiteContext);
    const [config, setConfig] = useState<DowntimeConfigResponse>();

    const LoadDowntimeConfiguration = async () => {
        const successCallback = (result: DowntimeConfigResponse) => {
            setConfig(result);
        };

        const failureCallback = () => {
            console.log('Failed to load countries');
        };

        new SiteApi().loadDowntimeConfiguration(
            successCallback,
            failureCallback
        );
    };

    useEffect(() => {
        LoadDowntimeConfiguration();
        GoogleAnalytics.setPageView(PageNames.Landing);
    }, []);

    useEffect(() => {
        if (isAuthenticated === true) {
            const verifiedUser = user?.email_verified === true;

            if (verifiedUser === true) {
                navigate(RoutePaths.Home);
            } else {
                logout({ logoutParams: { returnTo: window.location.origin } });
            }
        }
    }, [isAuthenticated]);

    return (
        <>
            <div className='warning-container'>
                {config &&
                    (config.messageType === DowntimeMessageType.Warning ||
                        config.messageType ===
                            DowntimeMessageType.Downtime) && (
                        <DowntimeComponent message={config.message} />
                    )}
            </div>
            <div className='landing-wrapper'>
                <img
                    alt='Landing Background Image'
                    className='background-img'
                    src={require(
                        `../../../images/${brandId}/landingPage/landing_background.png`
                    )}
                />
                <div className='landing-login-form-wrapper'>
                    <img
                        alt='Company Logo'
                        src={require(
                            `../../../images/${brandId}/landingPage/landing_company_logo.png`
                        )}
                    />

                    {config &&
                    config.messageType === DowntimeMessageType.Downtime ? (
                        <></>
                    ) : (
                        <AuthenticationButton />
                    )}
                </div>
            </div>
        </>
    );
};

export default LandingPage;
